import type { ReservationPolicy } from '@wineryxplorer/shared';

interface ReservationPolicyDisplayProps {
  value?: ReservationPolicy;
  className?: string;
}

const RESERVATION_POLICY_LABELS: Record<ReservationPolicy, string> = {
  required: 'Reservation required',
  recommended: 'Reservations recommended',
  'drop-ins-welcome': 'Drop-ins welcome',
};

const RESERVATION_POLICY_DESCRIPTIONS: Record<ReservationPolicy, string> = {
  required: 'Walk-ins not accepted — book in advance',
  recommended: 'Drop-ins welcome but advance booking suggested',
  'drop-ins-welcome': 'No reservation needed',
};

// Display fallback: undefined → 'recommended' (project default).
// Once dev DB is backfilled this fallback is unreachable for venues, but it's
// kept as a defensive guard for callers that might pass undefined.
export const ReservationPolicyDisplay = ({
  value,
  className = '',
}: ReservationPolicyDisplayProps) => {
  const effective: ReservationPolicy = value ?? 'recommended';
  const label = RESERVATION_POLICY_LABELS[effective];
  const description = RESERVATION_POLICY_DESCRIPTIONS[effective];

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      <span
        className="text-gray-900 font-medium text-sm sm:text-base"
        title={description}
        aria-label={`Reservation policy: ${label} — ${description}`}
      >
        {label}
      </span>
    </div>
  );
};
